export const getEnumByEnumValue = <T extends { [index: string]: string }>(
  enumClass: T,
  enumValue: string,
): T[keyof T] | null => {
  const keys = Object.keys(enumClass).filter((x) => enumClass[x] == enumValue);
  const key = keys.length > 0 ? keys[0] : null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return key ? (enumClass as any)[key] : null;
};
